<template>
  <hr>
  <el-row class="mb-15 group-title-table">
    <el-col :span="12" class="table-quantity-data">{{ $t('quantity_item_is_showing_table_header', [recordStart, recordEnd, data.total]) }}</el-col>
    <el-col :span="12" class="text-right" v-if="hasCreate">
      <el-button type="success" class="btn-create" @click="$emit('handleRedirectCreate')" >{{ $t('btn_create') }}</el-button>
    </el-col>
  </el-row>
  <el-table :data="data.records" id="table" @sort-change="sortChange" v-loading="loading" :empty-text="$t('table.no_data')">
    <el-table-column
      type="index"
      :index="indexMethod"
      width="75"
      label="No."
      v-if="showIndex"
      :class-name="'index'"
      :label-class-name="'label-index'"
    />
    <el-table-column v-for="(column, index) in columns"
      :key="index"
      :label="column.label"
      :sortable="column.sortable"
      :class-name="column.class"
      :prop="column.prop"
      :width="column.width"
      :label-class-name="column.labelClass"
      :align="column.align"
    >
      <template v-slot="scope">
        <p v-html="scope.row[column.prop]"></p>
      </template>
    </el-table-column>
    <el-table-column v-if="buttons && buttons.length" align="right" :width="widthButton">
      <template #default="scope">
        <el-button size="small" v-for="(button, index) in buttons" :class="button.class" :key="index"
          @click="$emit('clickButton', button.type, scope.row)">{{button.label}}
        </el-button>
      </template>
    </el-table-column>
    <el-table-column v-if="links && links.length" align="right">
      <template #default="scope">
         <el-link v-for="(link, index) in links"
          :class="link.class" :key="index" :underline="false" @click="$emit('clickLink', link.type, scope.row)">
          {{ link.label }}
        </el-link>
      </template>
    </el-table-column>
  </el-table>
  <p class="table-quantity-data padding-top-list text-center">
    {{ $t('quantity_item_is_showing_table_footer', [data.total, recordStart, recordEnd]) }}
  </p>
  <el-pagination
    background
    layout="prev, pager, next"
    :total="data.total" :page-size="data.perPage"
    prev-text="＜ 前へ" next-text="次へ ＞"
    :currentPage="data.currentPage"
    @current-change="handleChangePage"
  />
</template>

<script>
  export default {
    props: {
      columns: { type: Array, required: true, default: [] },
      data: { type: Object, required: true, default: [] },
      buttons: { type: Array, required: false, default: [] },
      loading: { type: Boolean, required: true, default: true },
      links: { type: Array, required: false, default: [] },
      showIndex: { type: Boolean, required: false, default: true },
      hasCreate: { type: Boolean, required: false, default: false },
    },
    emits: ['changePage', 'clickButton', 'sort', 'clickLink', 'handleRedirectCreate'],
    methods: {
      handleChangePage(page) {
        this.$emit('changePage', page);
      },

      indexMethod(index) {
        return (this.data.currentPage - 1) * this.data.perPage + index + 1;
      },

      sortChange(sortProps) {
        this.$emit('sort', sortProps);
      },
    },

    computed: {
      recordStart() {
        return (this.data.total > 0) ? (this.data.currentPage - 1) * this.data.perPage + 1 : 0;
      },

      recordEnd() {
        const temp = this.data.currentPage * this.data.perPage;
        return (temp >= this.data.total) ? this.data.total : temp;
      },
      widthButton() {
        return (this.buttons.length > 1) ? 230 : 100
      }
    },
  }
</script>

<style lang="scss">
  .link-detail {
    font-size: 11px;
  }
  .group-title-table {
    align-items: flex-end;
    line-height: normal;
    &>div {
      line-height: 1;
    }
  }
  .status-pending {
    width: 63px;
    height: 22px;
    text-align: center;
    letter-spacing: 1px;
    color:#468349;
    opacity:1;
    border: 1px solid #468349;
  }
  .status-inactive {
    width: 63px;
    height: 22px;
    text-align: center;
    letter-spacing: 1px;
    color:#FFFFFF;
    opacity:1;
    background: #969696 0 0 no-repeat padding-box;
  }
  .status-active {
    width: 63px;
    height: 22px;
    text-align: center;
    letter-spacing: 1px;
    color:#FFFFFF;
    opacity:1;
    background: #468349 0 0 no-repeat padding-box;
  }
  .el-input.company-name {
    width: 90%;
  }
  .el-input.shop-name {
    width: 90%;
  }
  .text-gray-500 {
    width: 5%;
  }
  .info {
    font-size: 20px;
  }
  .index {
    font: normal normal normal 11px/29px Kozuka Gothic Pr6N !important;
  }
  .label-index {
    font: normal normal normal 12px/29px Kozuka Gothic Pr6N !important;
  }
</style>
